import EditIcon from "@mui/icons-material/Edit";
import { IconButton, Tooltip } from "@mui/material";
import moment from "moment-jalaali";
import "moment-timezone";
import classes from "./style.module.scss";

const Message = ({ isUserOwner, message, fileURL, createdTime, onEdit }) => {
  return (
    <>
      <div
        className={`${isUserOwner ? classes.left_messages : classes.right_messages} ${
          classes.message
        }`}
      >
        {message}
        {isUserOwner && (
          <Tooltip title="ویرایش">
            <IconButton className={classes.editButton} onClick={() => onEdit?.(message, fileURL)}>
              <EditIcon />
            </IconButton>
          </Tooltip>
        )}
        {fileURL && (
          <a
            className={classes.messageFile}
            href={fileURL}
            download
            target="_blank"
            rel="noreferrer"
          >
            دانلود پیوست
          </a>
        )}
        <span>
          {moment
            .utc(createdTime.split(" - ").join(" "))
            .tz("Asia/Tehran")
            .format("jYYYY/jMM/jDD HH:mm:ss")}
        </span>
      </div>
    </>
  );
};

export default Message;
